// ─────────────────────────────────────────────
//  UnitPicker.jsx — Chip selector for unit of measure
// ─────────────────────────────────────────────

import React from 'react';
import styles from './UnitPicker.module.css';

export default function UnitPicker({ units, active, onSelect }) {
	return (
		<div className={styles.row} role="group" aria-label="Unidad de medida">
			{units.map((u) => (
				<button
					key={u.id}
					type="button"
					className={`${styles.chip} ${active === u.id ? styles.active : ''}`}
					onClick={() => onSelect(u.id)}
					aria-pressed={active === u.id}
				>
					{u.label}
				</button>
			))}
		</div>
	);
}
